import { styled, TextField } from '@mui/material'

export const PhonePrefix = styled(TextField)(({ theme }) => ({
  flexBasis: 35,
  '& .MuiInput-root': {
    minHeight: '48px',
    alignItems: 'flex-end',
  },
  '& .MuiInputBase-input': {
    width: 'auto',
    height: theme.spacing(6),
    padding: 0,
    lineHeight: '24px',
  },
  '& .MuiInput-formControl.Mui-disabled': {
    backgroundColor: 'transparent',
  },
  '& .MuiInput-underline.Mui-disabled': {
    '&:before': {
      borderBottomStyle: 'solid',
    },
  },
}))

PhonePrefix.defaultProps = {
  variant: 'standard',
}

export const PhoneInputWrap = styled('div')(({ theme }) => ({
  width: '100%',
  '& input': {
    height: theme.spacing(6.5),
  },
}))
